import { useQuery, UseQueryOptions } from '@tanstack/react-query';
import { sanityFetch } from '../../../sanity/lib/client';

export function useSanityQuery<T>(
  key: string[],
  query: string,
  params?: Record<string, unknown>,
  options?: Omit<UseQueryOptions<T, Error, T, string[]>, 'queryKey' | 'queryFn'>
) {
  return useQuery({
    queryKey: key,
    queryFn: () => sanityFetch<T>(query, params),
    // Editor-driven content: prefer freshness over caching.
    staleTime: 0,
    refetchOnWindowFocus: true,
    refetchOnMount: true,
    ...options,
  });
}
